<section class="effective-selection">
  @if (showHeading) {
    <div class="effective-selection-heading">
      <div>
        <h5>{{ 'software_override.effective.title' | translate }}</h5>
        <p>
          {{
            (forLicenseBatch
              ? 'software_override.effective.license_batch_description'
              : 'software_override.effective.description'
            ) | translate
          }}
        </p>
      </div>
      <span>
        {{
          'software_override.count.components'
            | translate: { count: visibleResolutions.length }
        }}
      </span>
    </div>
  }

  @if (forLicenseBatch) {
    <p class="license-batch-notice">
      {{ 'software_override.effective.license_batch_notice' | translate }}
    </p>
  }

  @if (visibleResolutions.length === 0) {
    <div class="empty-state">
      {{ 'software_override.effective.empty' | translate }}
    </div>
  } @else {
    <div class="selection-groups">
      @for (group of resolutionGroups; track group.status) {
        <section
          class="selection-group"
          [class.error-group]="group.status === 'error'"
        >
          <div class="selection-group-heading">
            <h6>{{ group.labelKey | translate }}</h6>
            <span>{{ group.resolutions.length }}</span>
          </div>

          <div class="selection-grid">
            @for (
              resolution of group.resolutions;
              track getResolutionTrackKey(resolution, $index)
            ) {
              <article
                class="selection-card"
                [class.selection-error]="isResolutionError(resolution)"
                [class.selection-device-dependent]="
                  isResolutionDeviceDependent(resolution)
                "
              >
                <div class="selection-card-heading">
                  <div>
                    <span>{{
                      'software_override.labels.component' | translate
                    }}</span>
                    <strong>
                      {{
                        resolution.component.name ||
                          resolution.component.id ||
                          ('software_override.effective.unknown_component'
                            | translate)
                      }}
                    </strong>
                  </div>
                  @if (resolution.spadokArtifact; as artifact) {
                    <span class="version">{{ artifact.version }}</span>
                  }
                </div>

                <dl class="selection-details">
                  <div>
                    <dt>{{ 'software_override.labels.scope' | translate }}</dt>
                    <dd>
                      {{
                        resolution.scope?.name ||
                          resolution.scope?.id ||
                          ('software_override.effective.not_available'
                            | translate)
                      }}
                    </dd>
                  </div>
                  @if (resolution.licenseBatch; as licenseBatch) {
                    <div>
                      <dt>
                        {{
                          'software_override.labels.license_batch' | translate
                        }}
                      </dt>
                      <dd>{{ licenseBatch.name || licenseBatch.id }}</dd>
                    </div>
                  }
                  <div>
                    <dt>
                      {{
                        'software_override.labels.selection_reason' | translate
                      }}
                    </dt>
                    <dd>{{ getResolutionSourceLabel(resolution) }}</dd>
                  </div>
                  <div>
                    <dt>{{ 'software_override.labels.result' | translate }}</dt>
                    <dd
                      class="selection-result"
                      [class.result-error]="isResolutionError(resolution)"
                    >
                      {{ getResolutionResultLabel(resolution) }}
                    </dd>
                  </div>
                </dl>
              </article>
            }
          </div>
        </section>
      }
    </div>
  }
</section>
